// extracted by mini-css-extract-plugin
module.exports = {"root":"Input_root__7nj3B","input":"Input_input__TI8gB"};